<template>
  <div>
    <div
      v-loading.fullscreen.lock="fullScreenLoading"
      element-loading-text="Loading, please wait..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>

    <div class="block">
      <el-tree
        ref="tree"
        :data="structure"
        node-key="id"
        highlight-current
        :default-expanded-keys="['0']"
        :draggable="draggable"
        :show-checkbox="showCheckbox"
        @node-click="nodeClick"
        :filter-node-method="filterNode"
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        empty-text="Empty Content"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-tooltip :content="data[nodeName]" placement="top" :open-delay="500">


            <span v-if="data[isService]== true" class="red min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
            </span>
            <span v-if="data[isService]== false" class="green min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
            </span>
            <span v-else-if="data[isService]== 0" class="black min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
            </span>
            <span v-else-if="data[isService]== 1" class="blue min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
            </span>
            <span v-else-if="data[isService]== 2" class="orange min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
              <!-- 如果节点存在descripition且在节点名中不包含descripition内容
               就为该节点添加description
               -->
              <span v-if="splitTableName(data)['description']&&splitTableName(data[nodeName].indexOf(splitTableName(data)['description'])) == -1">
                {{'('+splitTableName(data)['description']+')'}}
              </span>
            </span>
            <span v-else class="black min-font">
              <i class="fa fa-server" aria-hidden="true"></i>
              {{ splitTableName(data[nodeName]) }}
            </span>

          </el-tooltip>
          <span>
            <!--<el-button size="mini"-->
            <!--type="success"-->
            <!--@click="addFunction(node)"><i class="fa fa-plus"></i></el-button>-->

            <!--<el-button size="mini"-->
            <!--type="primary"-->
            <!--@click="editFunction(node)"><i class="fa fa-edit"></i></el-button>-->

            <!--<el-button size="mini"-->
            <!--type="danger"-->
            <!--@click="removeFunction(node)"-->
            <!--v-if="node.level !== 1"><i class="fa fa-remove"></i></el-button>-->
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import util from "@/util/util.js";
export default {
  name: "data-source-structure",
  props: {
    defaultExpandAll: {
      type: Boolean,
      required: false,
      default: () => false
    },
    showCheckbox: {
      type: Boolean,
      required: false,
      default: () => false
    },
    draggable: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data() {
    return {
      fullScreenLoading: false,
      confirmToRemovekeyDialogVisible: false,
      addFunctionDialogVisible: false,
      editDataFacetKeyDialogVisible: false,
      confirmToRemoveKey: false,
      confirmToRemoveDialogVisible: false,
      dsDescription: "",
      newDfKey: "",
      nodeName: "",
      isService:'',
      structure: [
        {
          id: "0",
          name: "ROOT",
          readChecked: false,
          readIndeterminate: false,
          writeChecked: false,
          writeIndeterminate: false,
          children: [],
          disabled: true
        }
      ]
    };
  },
  computed: {
    dfKey() {
      return "";
    }
  },
  created() {},
  methods: {
    initTree(structure, nodeName,isService) {
      try{
        this.nodeName = nodeName;
        this.isService = isService;
        this.structure[0][nodeName] = "ROOT";
        this.structure[0].children = [];
        this.structure[0].children = structure;
        let currentKey = this.$refs.tree.getCurrentKey();
        if (!currentKey) {
          this.$refs.tree.setCurrentKey("0");
        }
        console.log("structure", this.structure);
      }catch (e) {
        console.info(e)
      }
    },
    editFunction(node) {
      this.$emit("editNode", node);
    },
    removeFunction(node) {
      this.$emit("removeNode", node);
    },
    addFunction(node) {
      this.$emit("addNode", node);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (
        (type === "prev" || type === "next") &&
        dropNode.data.name === "ROOT"
      ) {
        return false;
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      return true;
    },
    getStructure() {
      return this.structure;
    },
    //表名最多只显示12个字符
    splitTableName(tableName) {
      if (tableName && tableName.length > 50) {
        return tableName.substring(0, 50) + "...";
      }
      return tableName;
    },
    filterNode(value, data) {
      if (!value) return true;
      if (data[this.nodeName]) {
        return data[this.nodeName].indexOf(value) !== -1;
      }
      return true;
    },
    getFunctionNodeKey() {
      return this.$refs.tree.getCurrentKey();
    },
    getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys();
    },
    getCurrentNode() {
      return this.$refs.tree.getCurrentNode();
    },
    getDataStructure() {
      return this.structure[0].children;
    },
    filter(value) {
      this.$refs.tree.filter(value);
    },
    nodeClick(data,node,myself){
      this.$emit("nodeClick",data);
    }
  }
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  /* overflow-x: auto; */
  /*此处添加滚动条效果不太好；
   *字符长度过长时，会在每一个过长的地方都会添加滚动条
   */
  /* 设置滚动条的样式 */





}
.black {
  color: black;
}
.red{
  color: red;
}
.blue{
  color: blue;
}
.orange{
  color: orange;
}
.green{
  color: green;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 2px 2px;
}

/*.el-select {*/
/*  width: auto !important;*/
/*}*/

/*.el-input {*/
/*  width: auto !important;*/
/*}*/
/*.el-textarea{*/
/*  width: auto !important;*/
/*}*/

.el-form-item__label {
  width: 112px;
  text-align: right !important;
}
.el-form--label-left /deep/ .el-form-item__label {
  width: 36%;
  text-align: right;
  font-size: 12px;
}

/*.el-input /deep/ .el-input__inner{*/
/*  width: 250px;*/
/*}*/

/*.el-textarea /deep/ .el-textarea__inner{*/
/*  width: 250px;*/
/*}*/

.el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #d7d6de;
}
.min-font {
  font-size: 12px;
}

/*/deep/ .el-textarea__inner{*/
/*    padding: 5px 15px 10px 5px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/view/acs/tree/tree_control.vue